'use strict';

function ConversionService () {
  //************ PRIVATE VARIABLES ************\\
  var DEFAULT_UNITS = 'imperial';
  var METRIC_UNITS = 'metric';

  //************ PUBLIC VARIABLES ************\\
  this.units = DEFAULT_UNITS;

  //************ PUBLIC METHODS ************\\
  this.getUnitsForProject = function getUnitsForProject (project) {
    var parsed = (project && project.meta) ? JSON.parse(project.meta) : {};
    this.units = parsed && parsed.units ? parsed.units : DEFAULT_UNITS;
  };

  this.isMetric = function isMetric () {
    return this.units === METRIC_UNITS ? true : false;
  };
}

ConversionService.$inject = [];

module.exports = ConversionService;



// WEBPACK FOOTER //
// ./src/app/dash/ConversionService.js